<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入手机号或邮箱" v-model="keywords"  style="width:300px;margin-right:20px" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="success" plain @click="dialog = true;event_time = ''">添加商品</el-button>
        </div>
        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <!-- <el-table-column type="selection" width="60" align="center"></el-table-column> -->
                <el-table-column label="商品图片" fixed align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.goods.image" :src="scope.row.goods.image.remote_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  align="center"  width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="商品状态"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_status == 0" style="color:#F56C6C">已下架</span>
                        <span v-else style="color:#67C23A">已上架</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="任务状态"  align="center">
                    <template slot-scope="scope">
                       <span>{{scope.row.status == 0 ? '未执行' : '已执行'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="event_time" label="执行时间"  align="center"></el-table-column>
                <el-table-column prop="created_at" label="操作时间"  align="center"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" width="200">
                    <template slot-scope="scope">
                        <div class="tables-btns">
                            <el-button type="success" plain size="mini" @click="handlePut(scope.row)">修改</el-button>
                            <el-button type="danger" plain size="mini" @click="handleDel(scope.row)">移除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
        <!-- 商品列表 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="1000px" center>
            <el-card shadow="never">
                <div class="m-bottom-3">
                    <el-input v-model="goodsSearch" @change="searchGoods()" clearable placeholder="搜索商品" prefix-icon="el-icon-search" style="margin-right: 20px; width: 180px"></el-input>
                    <el-date-picker v-model="event_time" value-format="timestamp"  type="datetime" placeholder="请选择时间"></el-date-picker>
                </div>
                <el-table :data="goodsData" @selection-change="handleChecked" max-height="450" ref="table" style="width: 100%">
                <el-table-column label="商品图片" align="center">
                    <template slot-scope="scope">
                    <m-img :src="scope.row.image_url"></m-img>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="min_price,max_price" align="center" label="价格" show-overflow-tooltip>
                    <template slot-scope="scope">
                    <div v-if="scope.row.max_price == scope.row.min_price">
                        C${{ scope.row.min_price }}
                    </div>
                    <div v-else>
                        C${{ scope.row.min_price }} - C${{ scope.row.max_price }}
                    </div>
                    </template>
                </el-table-column>
                <el-table-column prop="off" label="是否折扣商品" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                    <span> 
                        {{ scope.row.off ? '是' : '否' }}
                    </span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="编辑">
                    <template slot-scope="scope">
                    <el-button size="mini" type="success" plain @click="handleAdd(scope.row)">添加</el-button>
                    </template>
                </el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next, jumper" style="padding: 10px" :total="goodsTotal" :page-size="goodsSize" @current-change="goodsMore"></el-pagination>
            </el-card>
        </el-dialog>

        <el-dialog title="修改商品" :visible.sync="putDialog" center width="600px">
            <el-row class="line-item">
               <el-col :span="4" class="item-label">执行时间：</el-col>
               <el-col :span="10">
                   <el-date-picker v-model="event_time" value-format="timestamp"  type="datetime" placeholder="请选择时间"></el-date-picker>
               </el-col>
            </el-row>
            <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button type="info" plain @click="putDialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button type="primary" plain @click="handleConfirm" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>
    </section>
</template>
<script>

import {  goods_list, task_list, task_add, task_put, task_del } from "@/api/goods.js"

import MImg   from '@/components/Image'
import {parseTime}   from '@/untils/index'
export default {
    components: { MImg },
    data() {
        return {
            lang: 'zh', // 语言
            keywords:'',
            page:1,
            total:0,
            size: 0,
            goodsSearch: '',
            goodsPage: 1,
            goodsTotal: 0,
            goodsSize: 0,
            tableData:[],
            dialog: false,
            event_time: '',
            putDialog: false,
            id:'', // 任务id
            goods_id: '', // 商品id
            goods_status: '' //  商品状态
        }
    },
    methods: {
        search() {
            this.page = 1;
            this.getData()
        },
        getData() {
            let params = {
                page: this.page,
            }
            if(this.keywords != '') {
                params.keywords = this.keywords
            }
            task_list(params).then(res => {
                if(res) {
                    this.tableData =  res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        // 获取上架商品
        getSales() {
            let params = {
                page: this.goodsPage,
                status: 1,
            };
            if (this.goodsSearch != "") {
                params.search = this.goodsSearch;
            }
            goods_list(params).then((res) => {
                if (res) {
                    this.goodsData = res.data.data;
                    this.goodsData.forEach(item => {
                        item.pic_image = {
                            url: item.image_url,
                            id: item.image
                        }
                    })
                    this.goodsTotal = res.data.total;
                    this.goodsSize = res.data.per_page;
                } else {
                    this.goodsData = []
                }
                this.$forceUpdate();
            });
        },
        goodsMore(page) {
            this.goodsPage = page;
            this.getSales();
        },
        // 搜索上架商品
        searchGoods() {
            this.goodsPage = 1;
            this.getSales();
        },
        handleAdd(row) {
            if(this.event_time == '') {
                this.$message({type: 'warning', message: '请选择时间'})
                return false
            }
            let params = {
                goods_id: row.id,
                event_time: parseTime(this.event_time),
                goods_status: 1
            }
            task_add(params).then(res => {
                if(res) {
                    this.$message({type: 'success', message: '添加成功'})
                    this.getData()
                }
            })
        },
        handlePut(row) {
            this.id = row.id
            this.goods_id = row.goods_id
            this.event_time = new Date(row.event_time).getTime()
            this.goods_status = row.goods_status
            this.putDialog = true
        },
        handleConfirm() {
            let params = {
                goods_id: this.goods_id,
                event_time: parseTime(this.event_time),
                goods_status: this.goods_status
            }
            task_put(this.id, params).then(res => {
                if(res) {
                    this.$message({type:'success', message: res.msg})
                    this.putDialog = false
                }
            })
        },
        // 单个删除
        handleDel(row) {
            this.$confirm(`此操作将移除商品： ${row.goods_info.name}, 是否继续?`, '提示', {
                type: 'warning'
            }).then(() => {
                task_del(row.id).then(res => {
                    if(res) {
                        this.$message({type:'success',message:'删除成功'})
                        this.getData()
                    }
                })
            }).catch()
        }
    },
    created(){
        this.getData()
        this.getSales()
    },
    activated() {
        sessionStorage.removeItem('goods_sku')
        this.getData()
        this.getSales()
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-group {
    margin-right: 20px;
    .el-radio--medium.is-bordered {
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        margin-right: 10px;
        margin-left: 0;
    }
}
.tables-btns {
    display: flex;
    justify-content: center;
    .el-button {
        margin-right: 5px;
    }
}
.line-item {
    margin-bottom: 20px;
}
.item-label {
    height: 40px;
    line-height: 40px;
}
</style>


